export default "__VITE_ASSET__d3yQDKXS__"